import React, { useState } from 'react';
import styled from 'styled-components';
import img from 'images/mapClustoer/sikdae_log.svg';

const Wrapper = styled.div`
  height: 100%;
`;

const StyledContainer = styled.div`
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  & img {
    height: 17px;
    margin-bottom: 13px;
  }

  & p {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: -0.06em;
    color: #000000;
  }

  & .display {
    width: min-content;
    margin: auto;
  }
`;

const Button = styled.button`
  width: 164px;
  height: 57px;
  left: calc(50% - 164px / 2);
  top: calc(50% - 57px / 2 - 32.5px);
  background: #ffffff;
  border: 1px solid #ededf2;
  box-sizing: border-box;
  border-radius: 8px;
  margin-bottom: 8px;
  color: #212529;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
`;

const ScreenSelection = ({ onClick }) => {
  return (
    <Wrapper>
      <StyledContainer>
        <img src={img} />
        <p>제휴 식당 선택</p>
        <div className="display">
          <Button onClick={() => onClick('MO')}>MO</Button>
          <Button onClick={() => onClick('PC')}>PC</Button>
        </div>
      </StyledContainer>
    </Wrapper>
  );
};

export default ScreenSelection;
